
import { Component, Vue, Prop } from "vue-property-decorator";
import { accountApi } from "../services/api/account/account";
import { UpdateFacePassportCommand } from "../services/api/models/UpdateFacePassportCommand.model";
import FaceDetector from "./FaceDetector.vue";
import TransitionMessage from "./TransitionMessage.vue";

@Component({ components: { TransitionMessage, FaceDetector } })
export default class RecognitionPassport extends Vue {
  @Prop() readonly profile: any;

  private errorMessageShow = false;
  private errorMessage = "";

  private passportPhoto = "";
  private facePhoto = "";
  private modalFaceDetector = false;
  private profilePicBase64 = "";
  private isCapture = false;
  private isUploadPhoto = false;
  private photo = "";
  private passportPicName = "";
  private passportPicBase64 = "";
  private validatePassportModal = false;

  private isSavingProfile = false;
  private constraints = {
    audio: false,
    video: { width: 200, height: 250 },
  };

  video: any;
  $t: any;

  photoTaken(isPhotoTaken: any, image: any) {
    this.modalFaceDetector = !isPhotoTaken;
    this.facePhoto = image;
    this.profilePicBase64 = image;
  }

  async uploadPhoto() {
    if (this.isCapture) {
      this.eventCamera(false);
    }
    this.photo = "";
    this.passportPhoto = "";
    this.isUploadPhoto = true;
    this.modalFaceDetector = false;
  }

  async eventCamera(isCapture: any) {
    this.isCapture = isCapture;
    this.isUploadPhoto = false;

    let n = navigator.mediaDevices;

    if (n.getUserMedia) {
      n.getUserMedia(this.constraints)
        .then((stream: any) => {
          const video = document.getElementById(
            "video-passport"
          ) as HTMLVideoElement;

          if (video) {
            video.srcObject = stream;
            video.onloadedmetadata = function () {
              video.play();
            };
            this.video = video;
            this.passportPhoto = "";
          }

          if (!this.isCapture) {
            stream.getTracks().forEach(function (track: any) {
              track.stop();
            });

            if (this.video) {
              this.video.srcObject.getTracks().forEach(function (track: any) {
                track.stop();
              });

              this.video.srcObject = null;
            }
          }
        })
        .catch((err: any) => {
          console.log(err);
          alert("The following error occurred: " + err.name);
        });
    } else {
      alert("getUserMedia not supported");
    }
  }

  deletePassportPic() {
    this.photo = "";
    this.passportPhoto = "";
    this.passportPicName = "";
    this.passportPicBase64 = "";
    this.isUploadPhoto = false;
  }

  async capturePhoto() {
    this.deletePassportPic();
    const canvas = this.$refs.canvaspassport as HTMLCanvasElement;
    let context = canvas.getContext("2d")!;
    context.drawImage(this.video, 0, 0, 200, 250);
    this.photo = canvas.toDataURL("image/jpeg");
    this.passportPhoto = this.photo;
    this.modalFaceDetector = true;
    this.eventCamera(false);
  }

  async passportPic(event: Event) {
    this.modalFaceDetector = false;
    let files = (event.target as HTMLInputElement).files;
    if (files !== null && files.length > 0) {
      let file = files.item(0);
      if (file !== null) {
        this.passportPicName = file.name;
        try {
          this.passportPicBase64 = await this.toBase64(file);
          this.passportPhoto = this.passportPicBase64;
          this.modalFaceDetector = true;
        } catch (err) {
          window.console.log(err);
          this.deletePassportPic();
        }
        return;
      }
    }

    this.deletePassportPic();
  }

  toBase64(file: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        let src = reader.result as string;
        let base64 = await this.toJpeg(src);
        resolve(base64);
      };
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });
  }

  toJpeg(src: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const canvas = document.createElement("canvas") as HTMLCanvasElement;
        canvas.width = width;
        canvas.height = height;
        let context = canvas.getContext("2d")!;
        context.fillStyle = "#fff";
        context.fillRect(0, 0, width, height);
        context.drawImage(img, 0, 0);
        const base64 = canvas.toDataURL("image/jpeg");
        resolve(base64);
      };
      img.onerror = (err) => reject(err);
      img.src = src;
    });
  }

  async saveFaceDetector() {
    if (this.passportPicBase64 && this.profilePicBase64) {
      /* Here endpoint valid images */

      this.isSavingProfile = true;
      try {
        const data = new UpdateFacePassportCommand(
          this.profile.passport,
          this.passportPicBase64?.split("base64,")[1] ?? "",
          this.profilePicBase64?.split("base64,")[1] ?? ""
        );

        await accountApi.updateFacePassport(data);
        this.isSavingProfile = false;
      } catch (error) {
        this.isSavingProfile = false;
        if (error?.response?.data) {
          this.errorMessageShow = true;
          this.errorMessage = this.$t(`errors.${error.response.data}`);
        }
      } finally {
        this.isSavingProfile = false;
      }
    }
  }
}
